import { createAction } from '@reduxjs/toolkit';

export const mediaDevicesChangeStarted = createAction('userMedia/mediaDevicesChangeStarted');
